import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { SettingsInfo, SubmitState, useSettingsInfo, useUpdateSettings } from 'api'
import Card from 'common/Card'
import { MountpointGroupMultiSelector } from 'side/MountpointGroupMultiSelector'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { strings } from 'strings'
import useStyles from './styles'

const SourceTable = () => {
  const { settingsInfo, loading, error } = useSettingsInfo()

  let content
  if (loading) content = <CircularProgress size={16} />
  else if (error) content = <Typography color="error">{error.message}</Typography>
  else if (settingsInfo) content = <SourceTableForm settingsInfo={settingsInfo} />
  return (
    <Card title={strings.groupsPermission} style={{ marginBottom: 3 }}>
      {content}
    </Card>
  )
}

const SourceTableForm = ({ settingsInfo }: { settingsInfo: SettingsInfo }) => {
  const classes = useStyles()

  const {
    formState: { isDirty },
    handleSubmit,
    reset,
    control,
  } = useForm()

  const updateSettings = useUpdateSettings()

  const [submitState, setSubmitState] = useState(SubmitState.None)

  const onSubmit: SubmitHandler<SettingsInfo> = (formData) => {
    setSubmitState(SubmitState.Submitting)
    updateSettings(formData)
      .then(() => {
        setSubmitState(SubmitState.Success)
        reset()
      })
      .catch((err) => {
        console.log(err.message)
        setSubmitState(SubmitState.Error)
      })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.section}>
        <MountpointGroupMultiSelector
          label="Sourcetable"
          name="sourcetableMountpointGroupIds"
          creator={false}
          control={control}
          defaultValue={settingsInfo?.sourcetableMountpointGroupIds}
        />
      </div>
      <div className={classes.submitSection}>
        <Button
          type="submit"
          variant="outlined"
          color="primary"
          disabled={!isDirty || submitState === SubmitState.Submitting}
          className={classes.submitButton}
        >
          {strings.apply}
        </Button>
      </div>
    </form>
  )
}

export default SourceTable
